import TransactionTypeTabs from './TransactionTypeTabs';

export default TransactionTypeTabs;
